import { NgModule } from '@angular/core';
import { ADD_TO_CART_FEATURE, CART_BASE_FEATURE } from '@spartacus/cart/base/root';
import { CmsConfig, provideConfig } from '@spartacus/core';

export const GEN_EMPTY_CART_FEATURE = 'genEmptyCart';

@NgModule({
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_BASE_FEATURE]: {
          module: () =>
            import('./cart-base.module').then((m) => m.GenCartBaseModule),
        }
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [ADD_TO_CART_FEATURE]: {
          module: () =>
            import('./product-add-to-cart/product-add-to-cart.module').then(
              (m) => m.GenAddToCartModule
            ),
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [GEN_EMPTY_CART_FEATURE]: {
          module: () =>
            import('./empty-cart/empty-cart.module').then(
              (m) => m.GenEmptyCartModule
            ),
          cmsComponents: ['CustomEmptyCartComponent'],
        },
      },
    }),
  ],
})
export class GenCartBaseFeatureModule { }
